import { render } from "./BeneficiaryAccountsTable.vue?vue&type=template&id=43d7bbf0&scoped=true"
import script from "./BeneficiaryAccountsTable.vue?vue&type=script&lang=js"
export * from "./BeneficiaryAccountsTable.vue?vue&type=script&lang=js"

import "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=43d7bbf0&scoped=true&lang=css&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43d7bbf0"]])

export default __exports__